import React from 'react';
import '../../../styles/howitworksrealestatefaq.scss';
import { Link as Li } from 'react-router-dom';

export default function HowitWorksrealestatefaq(props) {
	const handleLink = () => {
		window.scrollTo(0, 0)
	}
	return (
		<div>
			<br />
			<div className="row w-100 justify-content-start">
				<div className="col-auto pr-0">
					<div className="how-list primary-background d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: `${props.partner && props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
						<span >1</span>
					</div>
				</div>
				<div className="col">
					<div className="how-content-realestatefaq">
						<li>
							<b>Get {`${props?.partner?.partner_name === ("Susser" || "susser") ? 'pre-qualified' : 'pre-approved' }`} quickly and easily</b>:
							Your client will fill out {props?.partner?.url_path === "megastar" ? <Li to="#" onClick={handleLink} style={{ color: 'black', fontWeight: 'bold', textDecoration: 'underline' }}>this</Li> : 'a'} 5-minute questionnaire on our website, and Calque will send them a {props?.partner?.url_path === 'revest' ? 'Calque Home Sale Guarantee™ (CHSG)' : 'guaranteed backup offer (GBO)'} within 3-5 business days. The {props?.partner?.url_path === 'revest' ? 'CHSG' : 'GBO'} assures your client that if their home doesn’t sell on the open market within a specified timeframe (usually {`${props?.partner?.partner_name === ("Susser" || "susser") ? '120' : '150'}`} days in most markets), Calque will buy it for a mutually agreed upon, fair price. Once your client accepts the {props?.partner?.url_path === 'revest' ? 'CHSG' : 'GBO'}, we will {`${props?.partner?.partner_name === ("Susser" || "susser") ? 'pre-qualify' : 'pre-approve'}`} them for their new home loan.
						</li>
					</div>
				</div>
			</div>
			<div className="row w-100 justify-content-start">
				<div className="col-auto pr-0">
					<div className="how-list primary-background d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: `${props.partner && props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
						<span >2</span>
					</div>
				</div>
				<div className="col">
					<div className="how-content-realestatefaq">
						<li>
							<b>Submit competitive offers with confidence</b>:
							You and your client can submit appealing, non-contingent offers that function like all-cash offers in today’s increasingly competitive real estate market. Once the offer is accepted on a new dream home, we will finalize the underwriting process and use the equity they have in their original home to give them the down payment for their new home for a conventional loan on the new property, avoiding costly PMI.
						</li>
					</div>
				</div>
			</div>
			<div className="row w-100 justify-content-start">
				<div className="col-auto pr-0">
					<div className="how-list primary-background d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: `${props.partner && props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
						<span >3</span>
					</div>
				</div>
				<div className="col">
					<div className="how-content-realestatefaq">
						<li>
							<b>Move and prep the original home for sale</b>:
							Your client moves into their new home and then makes repairs and stages the original home for sale. When the original home is ready for sale, you’ll determine the list price and list it on the open market.
						</li>
					</div>
				</div>
			</div>
			<div className="row w-100 justify-content-start">
				<div className="col-auto pr-0">
					<div className="how-list primary-background d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: `${props.partner && props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
						<span >4</span>
					</div>
				</div>
				<div className="col">
					<div className="how-content-realestatefaq">
						<li>
							<b>Sell the original home and save</b>:
							Sell your client's original home on the open market for maximum value. If they aren’t able to sell and close on it within the specified time frame (usually {`${props?.partner?.partner_name === ("Susser" || "susser") ? '120' : '150'}`} days in most markets), Calque will buy it for the {props?.partner?.url_path === "megastar" ? 'agreed upon price' : props?.partner?.url_path === "revest" ? 'CHSG' : 'GBO'}. Either way, your client will move forward with a conventional  loan on their new home.
						</li>
					</div>
				</div>
			</div>
		</div>
	)
}